import React from 'react';
import { Flex, H1, P } from '@decisiv/ui-components';
import { t, Trans } from '@lingui/macro';
import { CommandSection, LineDivider } from './style';
import CommandSearch from './commandSearch';
import Helmet from '../../components/SEO/Helmet';

export default function CommandPage() {
  return (
    <>
      <Helmet title={t`Commands`} description={t`Commands`} />
      <CommandSection
        flexDirection="column"
        justifyContent="center"
        padding={2}
        flex="none"
        flexGrow="0"
      >
        <Flex flexDirection="row">
          <Flex flex={1} title="Commands">
            <H1>Commands</H1>
          </Flex>
        </Flex>
        <P color="alaskanHusky">
          <Trans>
            Browse the catalog of available integration commands. Explore their
            configuration requirements, compatible connections, and the global
            and location-level settings each command needs.
          </Trans>
        </P>
      </CommandSection>
      <LineDivider />
      <CommandSearch />
    </>
  );
}
